import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/RotateLeftOutlined.js";
import f from "../components/PfIcon.js";
const t = (e, o) => {
  const r = {
    ...e,
    ...o.attrs
  };
  return a(f, i(r, {
    icon: n
  }), null);
};
t.displayName = "RotateLeftOutlined";
t.inheritAttrs = !1;
export {
  t as default
};
